module.exports = __webpack_public_path__ + "img/MH.87e38389.png";